module.exports = __webpack_public_path__ + "190478a456c6c23b1c58d687a4275c2e.fbx";